import * as types from "./actionTypes";
import * as doctorApi from "../../api/doctorApi";

// Action для загрузки докторов
export function loadDoctorsSuccess(doctors) {
  return { type: types.LOAD_DOCTORS_SUCCESS, doctors };
}

// Action для загрузки специализаций
export function loadSpecialitiesSuccess(specialities) {
  return { type: types.LOAD_SPECIALITIES_SUCCESS, specialities };
}

// Action для загрузки филлиалов
export function loadBranchesSuccess(branches) {
  console.log(branches);

  return { type: types.LOAD_BRANCHES_SUCCESS, branches };
}

// Функция загрузки докторов
export function loadDoctors() {
  return function (dispatch, getState) {
    // Проверяем, загружены ли уже данные о докторах
    const state = getState();
    if (state.doctors && state.doctors.length > 0) {
      return Promise.resolve(); // Если данные уже есть, ничего не делаем
    }

    return doctorApi
      .getDoctors()
      .then((doctors) => {
        console.log(doctors);
        dispatch(loadDoctorsSuccess(doctors));
        // После загрузки докторов, извлекаем специализации и филлиалы из этих данных
        let specialitiesData = [];
        let branchesData = [];

        const branchNamesSet = new Set();

        doctors.forEach((element) => {
          specialitiesData.push({
            Name: element.SpecialityName,
          });

          if (!branchNamesSet.has(element.Branch)) {
            branchNamesSet.add(element.Branch);
            branchesData.push({
              Name: element.Branch,
            });
          }
        });

        dispatch(loadBranchesSuccess(branchesData));
        dispatch(loadSpecialitiesSuccess(specialitiesData));
      })
      .catch((error) => {
        throw error;
      });
  };
}
